window.dataLayer = window.dataLayer || [];

import {
  clickHandler,
  determineActionText,
  queryURL,
} from '@/ui/scripts/analytics/analytics.methods';

const eventName = 'cardListing_tracking';
const actionPropTitle = 'cardListing_action';
const labelPropTitle = 'cardListing_label';

const cardListing = [...document.querySelectorAll('.js-card-listing-ga')];
const titleClass = '.js-card-title-ga';

function bindEventListener(el, title) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventName,
      actionProp: actionPropTitle,
      labelProp: labelPropTitle,
      action: `Click - ${determineActionText(el)} - ${title ? title : `No title`}`,
      label: queryURL(el),
    }),
  );
}

function init() {
  if (!cardListing.length) {
    return;
  }

  cardListing.forEach((comp) => {
    const cards = [...comp.querySelectorAll('.js-card-ga, .js-video-card-ga')];

    cards.forEach((card) => {
      const title = card.querySelector(titleClass)?.textContent.trim();
      const links = card.querySelectorAll('a');

      links.forEach((el) => bindEventListener(el, title));
    });
  });
}

export default init;
